import { Box, Flex, Link, Text } from "@chakra-ui/react";

import { BuildInfo } from "../components/BuildInfo";

const Footer = () => {
  return (
    <Flex
      width="full"
      align="center"
      alignSelf="flex-end"
      justifyContent="center"
      borderTop="1px solid"
      borderTopColor={"gray.200"}
      bg={"white"}
      p={"15px"}
      flexWrap="wrap"
      gap={2}
      position="relative"
    >
      <Text fontSize="xs">
        Copyright &copy; {new Date().getFullYear()} by{" "}
        <Link href="https://www.frenchteachers.org/concours" isExternal>
          AATF
        </Link>
      </Text>

      <Box position="absolute" right={4}>
        <BuildInfo />
      </Box>
    </Flex>
  );
};

export default Footer;
